import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollGetDraftEmployeeGraphQLRequest, PayrollGetDraftEmployeeResponse } from '../types';

const payrollGetDraftEmployeeQuery = gql`
  query PayrollGetDraftEmployee($draftEmployeeId: Int!) {
    payrollGetDraftEmployee(draftEmployeeId: $draftEmployeeId) {
      code
      success
      message
      data {
        basicDetails {
          name
          email
          hireDate
          designation
          department
          managerPeopleId
          managerName
          location
          officeLocationId
          emailNotPresent
        }
        compensationDetails {
          salaryStructureType
          salaryStructureId
          ctc
          variablePay
          earnings {
            basic
            hra
            lta
            sa
            da
            pf
            esi
            nps
            customAllowances {
              name
              value
              taxable
            }
          }
        }
        complianceDetails {
          isTds
          isPf
          isPt
          isEsi
          isLwf
        }
        userStatutoryDetails {
          panNumber
          panVerificationStatus
          locationPt
          locationLwf
          pfStatus
          esicStatus
          pfUan
          esicIp
        }
      }
    }
  }
`;

export const getDraftEmployee = (draftEmployeeId: number) => {
  return graphQLApi<PayrollGetDraftEmployeeResponse, PayrollGetDraftEmployeeGraphQLRequest>({
    query: payrollGetDraftEmployeeQuery,
    queryVariables: { draftEmployeeId },
  });
};
